import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    title: 'ABC Finance – Log In',
    loadComponent: () => import('./features/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'portal',
    canActivate: [authGuard],
    loadComponent: () => import('./features/portal/portal-shell').then((m) => m.PortalShell),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'payments' },
      {
        path: 'payments',
        loadChildren: () => import('./features/payments/payments.routes').then((m) => m.PAYMENTS_ROUTES),
      },
      {
        path: 'updates',
        loadChildren: () =>
          import('./features/account-updates/account-updates.routes').then((m) => m.ACCOUNT_UPDATES_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
